module.exports = __webpack_public_path__ + "img/logo-sm.0392f486.png";